import { Coins } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';
import { useCommonStore } from 'state/store/common/useCommonStore';
import { useSettingsDialogStore } from 'state/store/settings-dialog/useSettingsDialogStore';
import { CREDITS_ERROR, CREDITS_TAB_ID, USAGE_LIMIT_CATEGORY } from '../constants/credits';

interface CreditsEmptyNoticeProps {
  category?: string;
  code?: string;
}

/** Under the message of a turn refused for want of credits: a way to top up, or who to ask. */
export const CreditsEmptyNotice = ({ category, code }: CreditsEmptyNoticeProps) => {
  const { t } = useTranslation();
  const isAdmin = useCommonStore((state) => state.isAdmin);
  const openSettings = useSettingsDialogStore((state) => state.openSettings);

  if (category !== USAGE_LIMIT_CATEGORY || code !== CREDITS_ERROR.creditsEmpty) return null;

  return (
    <div className="mt-3 flex flex-wrap items-center gap-3 border-t border-border/70 pt-3">
      {isAdmin ? (
        <Button size="sm" onClick={() => openSettings(CREDITS_TAB_ID)}>
          <Coins aria-hidden="true" />
          {t('TOP_UP_CREDITS', 'Top up credits')}
        </Button>
      ) : (
        <p className="text-xs text-muted-foreground">
          {t('ASK_ADMIN_TO_TOP_UP', 'Ask your organization admin to top up.')}
        </p>
      )}
    </div>
  );
};
